var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 110,
    viewBox: "0 0 99 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4999 55V55.5H54.9999H70.2928L49.4999 76.2929L28.7071 55.5H43.9999H44.4999V55V33.5H54.4999V55ZM66.4999 11V10.5H65.9999H11H10.5V11V99V99.5H11H87.9999H88.4999V99V33V32.5H87.9999H66.4999V11ZM98.4998 104.462L98.4999 104.465C98.5045 105.122 98.3797 105.773 98.1327 106.381C97.8857 106.99 97.5212 107.543 97.0602 108.011C96.5991 108.478 96.0505 108.851 95.4456 109.106C94.8414 109.361 94.1929 109.495 93.537 109.5H5.46285C4.15051 109.49 2.89457 108.965 1.96607 108.037C1.03753 107.11 0.510978 105.854 0.5 104.542V5.456C0.5 2.72141 2.73136 0.5 5.49449 0.5H71.2928L98.4999 27.7071L98.4998 104.462Z",
    fill: "#878787",
    stroke: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6bbb081573549519ecf0bfd254d78cdc.svg";
export { ForwardRef as ReactComponent };